import { render, staticRenderFns } from "./ReadingTask2.vue?vue&type=template&id=29c80191&scoped=true&"
import script from "./ReadingTask2.vue?vue&type=script&lang=ts&"
export * from "./ReadingTask2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c80191",
  null
  
)

export default component.exports